import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { IcdCodesPopupComponent } from '../icd-code/icd-codes-popup/icd-codes-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { AppMessageService } from '../../services/app-message/app-message.service';
import { IcdCodeDropdownComponent } from '../../../ui-components/icd-code-dropdown/icd-code-dropdown.component';

export enum DiagnosesSavedType {
  ambulance = 'ambulance',
  user='user'
}
@Component({
  selector: 'app-medical-records',
  templateUrl: './medical-records.component.html',
  styleUrl: './medical-records.component.scss',
})
export class MedicalRecordsComponent implements OnChanges {
  @ViewChild('icdCodePopup') icdPopup: IcdCodesPopupComponent;
  @ViewChild('icdCodeDropdown') icdCodeDropdown: IcdCodeDropdownComponent;
  // @ViewChildren('icdCodeDropdownEdit') icdCodeDropdownEdit!: QueryList<IcdCodeDropdownComponent>;
  @ViewChild('icdCodeDropdownEdit')
  icdCodeDropdownEdit!: IcdCodeDropdownComponent;

  @Output() medicalRecordsChange = new EventEmitter<any[]>();
  @Input() medicalRecords?: any[] = [];
  //@Input() icdCodes: any[] = [];
  @Input() isReadOnly = false;
  @Input() showType:'user'|'ambulance'|null;

  medicalRecordItems: Array<any> = [];
  newMedicalRecordItem: boolean = false;
  newMedicalRecordData = {
    icd: {
      icdCodeId: null,
      icdCodeName: null,
      icdCode: null,
      label: null,
    },
    description: null,
  };
  selectedRow: any;
  editingIndex: number | null = null;
  activeTooltipIndex: number | null = null;
  tooltipPosition = { x: 0, y: 0 };

  constructor(
    private readonly translate: TranslateService,
    private readonly messageService: AppMessageService
  ) {}


  ngOnChanges(changes: SimpleChanges) {
    if (changes['medicalRecords']?.currentValue) {
      this.medicalRecordItems = changes['medicalRecords'].currentValue.map(
        (item: any) => ({
          ...item,
          icd: item?.icd
            ? {
                icdCodeId: item?.icd.icdCodeId,
                icdCodeName: item?.icd.icdCodeName,
                icdCode: item?.icd.icdCode,
                label:
                  item?.icd.icdCode && item?.icd.icdCodeName
                    ? `${item?.icd.icdCode} ${item?.icd.icdCodeName}`
                    : '',
              }
            : {
                icdCodeId: item?.icdCodeId,
                icdCodeName: item?.icdCodeName,
                icdCode: item?.icdCode,
                label:
                  item?.icdCode && item?.icdCodeName
                    ? `${item?.icdCode} ${item?.icdCodeName}`
                    : '',
              },
        })
      );
    }
  }

  newHeadItem() {
    this.cancel();
    this.newMedicalRecordItem = !this.newMedicalRecordItem;
    this.newMedicalRecordData = {
      icd: {
        icdCodeId: null,
        icdCodeName: null,
        icdCode: null,
        label: null,
      },
      description: null,
    };
    
    setTimeout(() => {
      if (this.icdCodeDropdown) {
        this.icdCodeDropdown.focusInputAndOpenDropdown();
      }
    }, 150);
  }

  cancel() {
    this.selectedRow = null;
    this.editingIndex = null;
  }

  trackByFn(index: number, item: any): any {
    return item?.id ?? index;
  }

  edit(item: any, index: number) {
    this.editingIndex = index;
    this.selectedRow = { ...item };
    setTimeout(() => {
      const comp = this.icdCodeDropdownEdit;
      comp?.setQuery(this.selectedRow?.icd?.label ?? '');
    });
    this.hideTooltip();
  }

  add() {
    if (
      !this.newMedicalRecordData?.icd?.icdCode &&
      !this.newMedicalRecordData?.description
    ) {
      return;
    }

    const newMedicalRecordData = { ...this.newMedicalRecordData };

    const isDuplicate = this.medicalRecordItems.some(
      (item) =>
        (newMedicalRecordData.icd.icdCodeId &&
          String(item?.icdCodeId) ===
            String(newMedicalRecordData?.icd?.icdCodeId)) ||
        (!newMedicalRecordData.icd.icdCodeId &&
          item?.description === newMedicalRecordData?.description)
    );

    if (isDuplicate) {
      this.messageService.warningToast(
        this.translate.instant('shared-components.duplicated-icd'),
        this.translate.instant('shared-components.duplicated-icd-exp')
      );
      return;
    }

    this.medicalRecordItems.push(newMedicalRecordData);

    this.newMedicalRecordData = {
      icd: {
        icdCodeId: null,
        icdCodeName: null,
        icdCode: null,
        label: null,
      },
      description: null,
    };

    const medicalRecordsToEmit = this.medicalRecordItems.map((item) => {
      return {
        ...item,
        icdCodeId: item?.icd.icdCodeId,
        icdCodeName: item?.icd.icdCodeName,
        icdCode: item?.icd.icdCode,
      };
    });

    this.icdCodeDropdown?.setQuery();
    this.newMedicalRecordItem =false;
    this.medicalRecordsChange.emit(medicalRecordsToEmit);
  }

  icdList() {
    this.icdPopup.initilize();
  }

  deleteItem(index: number): void {
    this.hideTooltip();
    this.medicalRecordItems.splice(index, 1);
    this.medicalRecordsChange.emit(this.medicalRecordItems);
  }

  saveItem() {
    if (!this.selectedRow?.icd?.icdCode && !this.selectedRow?.description) {
      return;
    }
    if (this.editingIndex === null) {
      const isDuplicate = this.medicalRecordItems.some(
        (item) =>
          (this.selectedRow?.icd?.icdCodeId &&
            String(item?.icdCodeId) ===
              String(this.selectedRow?.icd?.icdCodeId)) ||
          (!this.selectedRow?.icd?.icdCodeId &&
            item?.description === this.selectedRow?.description)
      );

      if (isDuplicate) {
        this.messageService.infoToast(
          this.translate.instant('shared-components.duplicated-icd'),
          this.translate.instant('shared-components.duplicated-icd')
        );
        return;
      }
    } else {
      const isDuplicate = this.medicalRecordItems.some(
        (item, index) =>
          ((this.selectedRow?.icd?.icdCodeId &&
            String(item?.icdCodeId) ===
              String(this.selectedRow?.icd?.icdCodeId)) ||
            (!this.selectedRow?.icd?.icdCodeId &&
              item?.description === this.selectedRow?.description)) &&
          index !== this.editingIndex
      );

      if (isDuplicate) {
        this.messageService.warningToast(
          this.translate.instant('shared-components.duplicated-icd'),
          this.translate.instant('shared-components.duplicated-icd-multi-exp')
        );
        return;
      }
    }

    if (this.editingIndex !== null) {
      this.medicalRecordItems[this.editingIndex] = { ...this.selectedRow };
    }

    const medicalRecordsToEmit = this.medicalRecordItems.map((item) => {
      return {
        ...item,
        icdCodeId: item?.icd?.icdCodeId,
        icdCodeName: item?.icd?.icdCodeName,
        icdCode: item?.icd?.icdCode,
      };
    });

    this.medicalRecordsChange.emit(medicalRecordsToEmit);

    this.selectedRow = null;
    this.editingIndex = null;
  }

  handlePopupData(selectedICDCodes: any[]) {
    for (const item of selectedICDCodes) {
      const isDuplicate = this.medicalRecordItems.some(
        (record) => String(record.icdCodeId) === String(item.id)
      );

      if (isDuplicate) {
        this.messageService.warningToast(
          this.translate.instant('shared-components.duplicated-icd'),
          this.translate.instant('shared-components.duplicated-icd-multi-exp')
        );
      } else {
        this.medicalRecordItems.push({
          icdCodeId: item?.id,
          icdCodeName: item?.name,
          icdCode: item?.code,
          description: '',
        });
      }
    }

    const medicalRecordsToEmit = this.medicalRecordItems.map((item) => {
      return {
        ...item,
        icdCodeId: item.icdCodeId,
        icdCodeName: item.icdCodeName,
        icdCode: item.icdCode,
      };
    });
    this.medicalRecordsChange.emit(medicalRecordsToEmit);
  }

  showTooltip(index: number, event: MouseEvent) {
    this.activeTooltipIndex = index;
    this.tooltipPosition = { x: event.clientX + 10, y: event.clientY + 10 };
  }

  hideTooltip() {
    this.activeTooltipIndex = null;
  }

  get currentLength(): number {
    return (this.newMedicalRecordData?.description || '').length;
  }

  get editedCurrentLength(): number {
    return (this.selectedRow?.description || '').length;
  }

  onIcdDropdownChange(item: any) {
    this.newMedicalRecordData.icd = item ?? {
      icd: {
        icdCodeId: '',
        icdCodeName: '',
        icdCode: '',
        label: '',
      },
      description: '',
    };
  }

  onSelectedIcdDropdownChange(item: any) {
    this.selectedRow.icd = item ?? {
      icd: {
        icdCodeId: '',
        icdCodeName: '',
        icdCode: '',
        label: '',
      },
      description: '',
    };
  }
}
